/// <amd-module name="Feed/Legacy/Actions/FeedSettings/DisplayRetentionPolicyHandler" />
import { FeedSettingsComponents } from "Feed/Common/Constants/Constants";
import { FeedRetentionPolicy } from "Feed/Common/Contracts/Feed";
import * as PackageResources from "Feed/Common/Resources";
import { IFeedSettingsState } from "Feed/Legacy/Components/Settings/IFeedSettingsState";
import { IFeedDataService } from "Feed/Legacy/DataServices/FeedsDataService";

/**
 * When user navigates to feed settings
 * 1. set loading spinner
 * 2. get feed's views from server
 * 3. set data is fetched from server
 */
export class DisplayRetentionPolicyHandler {
    public static async handleAsync(state: IFeedSettingsState, emit: () => void): Promise<void> {
        if (state.retentionPolicySettings.retentionPolicy || !state.feed()) {
            return Promise.resolve();
        }

        state.retentionPolicySettings.retentionPolicyLoading = true;
        emit();

        try {
            state.validationErrorBag[FeedSettingsComponents.feedRetentionPolicyMaxVersions] = null;
            const feedDataService = state.pageContext.getService<IFeedDataService>("IFeedDataService");
            const feed = state.feed();
            const projectId = feed.project ? feed.project.id : null;
            const retentionPolicy = await feedDataService.getFeedRetentionPolicy(projectId, feed.id);
            state.retentionPolicySettings.retentionPolicy =
                retentionPolicy ||
                ({ countLimit: null, daysToKeepRecentlyDownloadedPackages: null } as FeedRetentionPolicy);
        } catch (error) {
            state.validationErrorBag[FeedSettingsComponents.feedRetentionPolicyMaxVersions] =
                PackageResources.Error_RetentionPolicyFailedToLoad;
            throw error;
        } finally {
            state.retentionPolicySettings.retentionPolicyLoading = false;
            emit();
        }
    }
}
